import { ReactNode } from 'react';
import { roleManagerDetailPages } from '../../../shared/pages-config';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';

interface RoleDetailsLayoutProps {
  tabsValue?: string;
  children?: ReactNode;
}

export default function RoleDetailsLayout({
  tabsValue,
  children,
}: RoleDetailsLayoutProps) {
  const matchingPage = Object.values(roleManagerDetailPages).find(
    (page) => page.link === tabsValue
  );

  const title = matchingPage?.name || tabsValue;

  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        mt: 0.5,
        px: 4,
        py: 2,
        height: '100%',
      }}
    >
      {title && (
        <Typography sx={{ fontSize: 24, textAlign: 'center', fontWeight: 400 }}>
          {title}
        </Typography>
      )}

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
        }}
      >
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            my: 1,
          }}
        >
          {children}
        </Box>
      </Box>
    </Card>
  );
}
